import axios from "axios";
import { getAuthHeader } from "@/services/user.service.js";

export {
  GetCantonalMinimumWages,
  CreateCantonalMinimumWage,
  SaveCantonalMinimumWage,
  DeleteCantonalMinimumWage,
  StartCantonalMinimumWageValidation,
  StartApplicationCantonalMinimumWageValidation,
  GetCantonalMinimumWageValidationState,
  GetCantonalMinimumWageValidationResults,
  GetCantonalMinimumWageValidationStates,
  GetMinimalsalaryvalidationstates,
  GetMinimalsalarypredictionstates,
  GetMinimalSalaryExclusions,
  AddMinimalSalaryExclusion,
  UpdateMinimalSalaryExclusion,
  DeleteMinimalSalaryExclusion
};

function GetCantonalMinimumWages(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/minimalsalary`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function CreateCantonalMinimumWage(wagesObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary`,
      wagesObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function SaveCantonalMinimumWage(wagesObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary`,
      wagesObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteCantonalMinimumWage(year, path, fromMonth, toMonth, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/${year}/${path}?fromMonth=${fromMonth + 1}&toMonth=${toMonth + 1}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}

function StartCantonalMinimumWageValidation(configId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/validate`,
      null,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function StartApplicationCantonalMinimumWageValidation(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/validate`,
      null,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function GetCantonalMinimumWageValidationState(configId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/state`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function GetCantonalMinimumWageValidationResults(configId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/results`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function GetCantonalMinimumWageValidationStates(onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(process.env.VUE_APP_BASE_API_URL + `/minimalsalary/state`, headers)
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      console.error(error);
      onError(error);
    });
}

function GetMinimalsalaryvalidationstates(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/enumlist/minimalsalaryvalidationstate`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}


function GetMinimalsalarypredictionstates(onSuccess, onError) {
  var headers = getAuthHeader();
  axios
    .get(
      process.env.VUE_APP_BASE_API_URL +
        `/enumlist/minimalsalarypredictionstate`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function GetMinimalSalaryExclusions(configId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .get(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/exclusions`,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });

}

function AddMinimalSalaryExclusion(configId, exclusionObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .post(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/exclusions`,
      exclusionObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function UpdateMinimalSalaryExclusion(configId, exclusionObject, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .put(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/exclusions/${exclusionObject.id}`,
      exclusionObject,
      headers
    )
    .then(response => {
      onSuccess(response.data);
    })
    .catch(error => {
      onError(error);
    });
}

function DeleteMinimalSalaryExclusion(configId, exclusionId, onSuccess, onError) {
  var headers = getAuthHeader();

  axios
    .delete(
      process.env.VUE_APP_BASE_API_URL + `/minimalsalary/configurations/${configId}/exclusions/${exclusionId}`,
      headers
    )
    .then(() => {
      onSuccess();
    })
    .catch(error => {
      onError(error);
    });
}